import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { STORAGE_KEY } from '@/i18n/config';

/**
 * Language detection hook — disabled.
 * English is always the default. Users can manually select a language via the LanguageSelector.
 * Geolocation-based detection is intentionally removed because translations are incomplete.
 */
export function useLanguageDetection() {
  const { i18n } = useTranslation();
  const checked = useRef(false);

  useEffect(() => {
    if (checked.current) return;
    checked.current = true;

    // Only honour a previously saved manual selection
    const manuallySelected = localStorage.getItem(STORAGE_KEY);
    if (manuallySelected && manuallySelected !== i18n.language) {
      i18n.changeLanguage(manuallySelected);
    }
    // Otherwise keep English (the fallbackLng set in i18n config)
  }, [i18n]);
}
